import { Button } from '@britishcouncil/react-admin';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath } from 'react-router';
import { ROUTING_PATHS } from 'const';

type Props = {
  isCreating: boolean;
  created: boolean;
};

export const Footer = ({ isCreating, created }: Props) => {
  const { speakingSessions } = ROUTING_PATHS;

  return (
    <Modal.Actions>
      <Link
        to={generatePath(speakingSessions.absolutePath)}
        data-testid="cancel-create-speaking-session"
      >
        <Button compact type="reset" secondary>
          Cancel
        </Button>
      </Link>

      <Button
        compact
        color="blue"
        type="submit"
        disabled={isCreating || created}
        loading={isCreating}
        data-testid="create-speaking-session"
      >
        Create
      </Button>
    </Modal.Actions>
  );
};
